import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ImpactShowcase() {
  return <section className="py-20 px-4 bg-transparent overflow-hidden pt-[0px] pb-[0px]" data-id="element-169" data-mp="3adk4viw6o50">
      <div className="max-w-7xl mx-auto" data-id="element-170" data-mp="3lo37vr31iaew">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-171" data-mp="3lp4i5tc8esvk">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-12" data-id="element-172" data-mp="3pon853iwtu59">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-6 tracking-tight uppercase" data-id="element-173" data-mp="87vijrza9kyr">
              TRANSFORMÁ LO ORDINARIO <br data-id="element-174" data-mp="d6gma1dqumry" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f0ff] to-[#8b5cf6]" data-id="element-175" data-mp="d9un356renxa">
                EN ALGO EXTRAORDINARIO
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-176" data-mp="2xzk2pkfaedr1">
              Con las técnicas de mi libro, vas a pasar de crear muebles comunes
              a piezas de arte tecnológico que dejan a todos sin palabras.
            </p>
          </motion.div>

          <div className="relative" data-id="element-177" data-mp="qvcnucyckzsl">
            <div className="absolute -inset-4 bg-gradient-to-r from-[#ec4899]/20 to-[#8b5cf6]/20 blur-2xl rounded-full opacity-50" data-id="element-178" data-mp="qwdzaij9zoau" />
            <div className="relative bg-[#1a0b2e]/40 border border-white/10 rounded-[2.5rem] p-8 md:p-12 overflow-hidden" data-id="element-179" data-mp="zvhlhvdqojtk">
              <img src="https://cdn.magicpatterns.com/uploads/gLJhYcveSfcMHf8SJ6rwQC/antes_y_despues.webp" alt="Transformación de taller triste a taller brillante con Neon Flex" width={800} height={600} className="w-full h-auto object-cover rounded-2xl" loading="lazy" decoding="async" data-id="element-180" data-mp="uxg2tbk86mim" />

              {/* Bottom Impact Text */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-8 pt-20" data-id="element-181" data-mp="1eiuc3yielfqt">
                <p className="text-white text-lg md:text-2xl font-bold italic" data-id="element-182" data-mp="1qmosxu04ff3f">
                  "El límite es tu imaginación..."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}